<template>
  <div>
    <div>
      <x-grid
          :id="'formList'"
          :rowId="rowId"
          :url="url"
          :columns="columns"
          :form-config="formConfig"
          :toolbar-config="toolbarConfig"
          :print-config="printConfig"
          :pager-config="pagerConfig"
          :checkbox-config="checkboxConfig"
          :export-config="exportConfig"
          ref="grid"
          :cellClick="chooseRow"
          :cellDbClick="updateRow"
          @toolbar-addData="addRow"
      >
        <template v-slot:[toolbarConfig.templatelSlots]>
          <vxe-button @click="download">下载模板</vxe-button>
          <a-upload
              name="file"
              :multiple="false"
              :accept="'.xlsx'"
              :action="api.visitTask.IMPORT"
              :headers="{ token:token }"
              :showUploadList="false"
              @change="handleFileChange"
              style="margin: 0 0 0 3px"
          >
            <vxe-button>导入</vxe-button>
          </a-upload>
        </template>

        <template v-slot:operate="{ row }">
          <vxe-button style="margin-right: 10px" size="mini" status="primary" @click="updateRow({row})">修改</vxe-button>
          <vxe-button style="margin-right: 10px" size="mini" @click="deleteTask(row)">删除</vxe-button>
        </template>
      </x-grid>

      <formModal
          title="大客户拜访任务"
          centered
          :footer="null"
          :maskClosable="false"
          :visible="editModalVisible"
          :width="800"
          :closable="true"
      >
        <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
        <detailForm
            :rowId="editRowId"
            v-if="editModalVisible"
            ref="detailForm"
            @saved="closeEdit(true)"
        >
        </detailForm>
      </formModal>
    </div>
  </div>
</template>

<script>
import XGrid from "@/components/grid/XGrid";
import api from "@/services/api";
import { GridMixin } from "@/utils/GridMixin";
import { dataApi } from "@/services/bigCustomer/visitTask";
import detailForm from "./add";
import axios from "axios";

const fac = XGrid.factory;
//列表接口
const url = api.visitTask.VISIT;
//主键
const rowId = "id";
//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("planVisitTimeStr", "计划拜访年月"),
  fac.makeColumn("responsibleDeptName", "责任部门"),
  fac.makeColumn("responsibleUserName", "责任人姓名"),
  fac.makeColumn("responsibleUserCode", "责任人用户编码"),
  fac.makeColumn("customerName", "客户名称"),
  fac.makeColumn("taskStatusStr", "任务状态"),
  fac.makeColumn({
    title: "操作",
    field: 'operate',
    slots: {
      default: 'default'
    },
    align: 'center',
    width: 200,
    fixed: 'right'
  }),
];

//筛选条件
const formConfig = fac.makeFormConfig(columns, [
  { field: "planVisitTime", title: "计划拜访年月", type: 'month', customSearch: true },
  { field: "responsibleDeptId", title: "责任部门", type: "select", options: [], customSearch: true },
  { field: "responsibleUserName", title: "责任人", customSearch: true },
  {
    field: "taskStatus",
    title: "任务状态",
    type: "select",
    options: [{ label: '全部', value: '' }, { label: '未完成', value: '0' }, { label: '已完成', value: '1' }],
    customSearch: true
  },
]);

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  addData: true,
  export: true,
  import: false,
  delData: false,
  templatelSlots: "toolbarBtns",
});

//可编辑表格约束
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

//初始化数据方法
async function loadBaseData() {
  //最近跟进人部门、拜访人部门
  this.regionOptions = await dataApi.selection()
  this.regionOptions = this.regionOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptId
    }
  })
  this.regionOptions = [{
    value: '',
    label: '全部'
  }].concat(this.regionOptions);
  this.loadSearchOption({
    responsibleDeptId: this.regionOptions,
  })
}

export default {
  mixins: [GridMixin],
  components: {
    detailForm
  },
  data() {
    return {
      rowId,
      url,
      columns,
      formConfig,
      toolbarConfig,
      printConfig,
      pagerConfig,
      checkboxConfig,
      exportConfig: {
        remote: true,
        types: ['xlsx'],
        modes: ['all']
      },
      regionOptions: [],
      token: localStorage.getItem('token'),
      editModalVisible: false,
    };
  },
  methods: {
    closeDetailPop() {
      this.editModalVisible = false;
    },
    loadBaseData,
    // 删除
    async deleteTask(row) {
      let vm = this;
      vm.$confirm({
        title: '您确认要删除该条数据吗？',
        async onOk() {
          let entity = await dataApi.deleteTask(row.id); //删除
          if (entity.code === 200) {
            vm.$message.success('删除成功');
            location.reload();
            vm.refresh();
          } else {
            vm.$message.warn(entity.data);
          }
        }
      })
    },
    download() {
      axios.get('visitTaskExample.xlsx', { //静态资源文件夹public
        responseType: 'blob',
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        let fname = '大客户拜访任务导入模板.xlsx';
        link.href = url;
        link.setAttribute('download', fname);
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
        console.log('error:' + JSON.stringify(error))
      });
    },
    /**
     * 上传
     */
    handleFileChange({file}) {
      if (file.status === 'done') {
        if (file.response.code === 500) {
          this.bus.$emit('loading', false);
          console.log('error', file)
          this.$message.error('导入数据不规范,示范文件下载中...')
          let downFile = api.visit.ERROREXCEL + 'error/' + file.response.msg + "?download=1";
          axios.get(downFile, {responseType: "blob"})
              .then((res) => {
                const blob = new Blob([res.data], {
                  type: "application/vnd.ms-excel;charset=utf-8",
                });
                const href = window.URL.createObjectURL(blob);
                const downloadElement = document.createElement("a");
                downloadElement.href = href;
                var name = res.headers["content-disposition"];
                downloadElement.download = decodeURI(name.substring(name.lastIndexOf("=") + 1));
                document.body.appendChild(downloadElement);
                downloadElement.click();
                document.body.removeChild(downloadElement);
                window.URL.revokeObjectURL(href);
              }).catch((fail) => {
            console.error(fail);
          });
        } else {
          console.log('success', file)
          this.bus.$emit('loading', false);
          this.$message.success('导入成功')
          this.refresh();
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
//新增的开始
/deep/ .ant-radio-group {
  display: flex;
  width: 100%;

  .ant-radio-wrapper {
    flex: 1;
  }

  .item {
    margin: 16px 0;
  }
}

.left_tree {
  width: 260px;
  float: left;
  padding: 20px;
  height: calc(100vh - 48px - 64px);
  border-right: 1px solid #e0e0e0;
  background: #fff;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
}

.right_table {
  width: calc(100% - 260px);
  float: right;
  height: 100%;
  position: relative;

  .close {
    position: absolute;
    top: 50%;
    left: -18px;
    display: block;
    z-index: 1000;
    font-size: 36px;
    cursor: pointer;
    color: #fff;
    background-color: #bbb;
    border-radius: 18px;
  }
}

.showLeft {
  width: 100%;
}
</style>
